<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     收费方案选择器
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-select v-model="schemeid" :placeholder="placeholder" filterable clearable @change="selectChange" :style="{ width: width + 'px' }">
    <el-option
      v-for="(item, index) in schemes"
      :key="index"
      :label="item.title"
      :value="item.schemeid">
      <span>{{ item.title }}</span>
      <span v-if="item.scheme_unit === 'year'" class="ml">
        {{ item.scheme_price | currency }} / 年
      </span>
      <span v-if="item.scheme_unit === 'month'" class="ml">
        {{ item.scheme_price | currency }} / 月
      </span>
      <span v-if="item.scheme_unit === 'once'" class="ml">
        {{ item.scheme_price | currency }} / 一次性
      </span>
    </el-option>
  </el-select>

</template>

<script>
import { allSchemeApi } from '@/api/ei/eiApi'

export default {
  name: "FSchemeSelector",

  props: {
    value: {
      type: Number,
      default: 0
    },

    placeholder: {
      type: String,
      default: '收费方案'
    },

    width: {
			type: String,
			default: '200'
		},
  },

  data() {
    return {
      schemes: []
    }
  },

  computed: {
    schemeid: {
      get() {
        return this.value ? this.value : null
      },
      set(val) {
        this.$emit('input', val ? val : null)
      }
    }
  },

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      allSchemeApi().then(res => {
        if (!res.errno) {
          this.schemes = res.data.list
        }
      })
    },
    
    selectChange(val) {
      const list = this.schemes.map(v => v.schemeid)
      const index = list.indexOf(val)
      const item = this.schemes[index]
      this.$emit('change', item)
    }
  }
}
</script>
